import { Vue, Component } from "vue-property-decorator";
import axios from "axios";
// Components
import { AddWarehouse, UpdateWarehouse, Snackbar } from "@/components/index";
// Entities
import { Warehouse } from "@/entities/index";

@Component({
  components: {
    AddWarehouse,
    UpdateWarehouse,
    Snackbar,
  },
})
export default class Warehouses extends Vue {
  warehouses: Warehouse[] = [];

  myWarehouseId = 0;
  warehouseName = "";
  warehouseCode = "";
  selectedWarehouse = {};

  updateWarehouseForm = false;

  headersWarehouseTable = [
    {
      text: "Nom de l'entrepôt",
      align: "start",
      value: "name",
      class: "indigo--text text--darken-4",
    },
    {
      text: "Code de l'entrepôt",
      value: "code",
      class: "indigo--text text--darken-4",
    },
    {
      text: "Actions",
      value: "updateWarehouse",
      class: "indigo--text text--darken-4",
      sortable: false,
    },
  ];

  // ========== CRUD ========== //

  handleEditWarehouse(item: Warehouse): void {
    this.myWarehouseId = item.id;
    this.selectedWarehouse = {
      name: item.name,
      code: item.code,
    };
    this.updateWarehouseForm = true;
  }

  handleUpdateWarehouse(updateWarehouse: any): void {
    axios
      .put(`/api/warehouses/${this.myWarehouseId}`, {
        name: updateWarehouse.name,
        code: updateWarehouse.code,
      })
      .then(() => {
        this.updateWarehouseForm = false;
        this.myWarehouseId = 0;
        this.showSnackbarUpdateWarehouse();
        this.allWarehouses();
      });
    this.updateWarehouseForm = false;
    this.showSnackbarUpdateWarehouse();
  }

  deleteWarehouse(id: number): void {
    axios
      .delete(`/api/warehouses/${id}`)
      .then(() => {
        this.showSnackbarDeleteWarehouse();
        this.allWarehouses();
      })
      .catch(() => {});
  }

  async allWarehouses(): Promise<void> {
    this.warehouses = (await axios.get(`/api/warehouses`)).data as Warehouse[];
  }

  mounted(): void {
    this.allWarehouses();
  }

  // ========== OTHER METHODS ========== //

  clear(): void {
    const btnClear = document.getElementById("btnClear");
    btnClear?.classList.add("clicked");
    setTimeout(() => {
      btnClear?.classList.remove("clicked");
    }, 500);

    this.warehouseName = "";
    this.warehouseCode = "";
  }

  colorRow(item: Warehouse): any {
    const position = this.warehouses.indexOf(item, 0);
    if (position % 2 == 0) {
      return "light-green lighten-5";
    }
  }

  showSnackbarUpdateWarehouse(): void {
    const snackbarUpdate = this.$refs.snackbarUpdateWarehouse as Snackbar;
    snackbarUpdate.show();
  }

  showSnackbarDeleteWarehouse(): void {
    const snackbarDelete = this.$refs.snackbarDeleteWarehouse as Snackbar;
    snackbarDelete.show();
  }
}
